export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 rounded-t-[32px] mx-6 lg:mx-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 lg:py-20">
        {/* Top Section */}
        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          {/* Newsletter - Left */}
          <div className="lg:col-span-5">
            <h3 className="font-serif font-light text-4xl lg:text-5xl text-white mb-4">
              Manténgase Informado
            </h3>
            <p className="text-gray-400 text-base leading-relaxed mb-8">
              Reciba actualizaciones sobre cambios legales y consejos jurídicos
            </p>
            <div className="space-y-4">
              <input
                type="email"
                placeholder="Su correo electrónico"
                className="w-full bg-transparent border-b-2 border-gray-600 py-3 text-white placeholder-gray-500 focus:border-gold outline-none transition-colors text-sm"
              />
              <button className="px-8 py-3 bg-white text-black text-sm font-semibold rounded-full hover:bg-gray-100 transition-all inline-flex items-center space-x-2 whitespace-nowrap cursor-pointer">
                <span>Suscribirse</span>
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-base"></i>
                </div>
              </button>
            </div>
          </div>

          {/* Navigation - Center */}
          <div className="lg:col-span-3">
            <h4 className="text-gray-500 text-xs font-semibold uppercase tracking-wider mb-6">
              Navegación
            </h4>
            <ul className="space-y-4">
              <li>
                <button
                  onClick={() => scrollToSection('inicio')}
                  className="text-gray-300 text-sm hover:text-gold transition-colors underline cursor-pointer"
                >
                  Inicio
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('sobre-mi')}
                  className="text-gray-300 text-sm hover:text-gold transition-colors underline cursor-pointer"
                >
                  Sobre Mí
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('servicios')}
                  className="text-gray-300 text-sm hover:text-gold transition-colors underline cursor-pointer"
                >
                  Servicios
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contacto')}
                  className="text-gray-300 text-sm hover:text-gold transition-colors underline cursor-pointer"
                >
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          {/* Contact - Right */}
          <div className="lg:col-span-4">
            <h4 className="text-gray-500 text-xs font-semibold uppercase tracking-wider mb-6">
              Contacto
            </h4>
            <div className="space-y-4 mb-8">
              <a href="tel:+50671075130" className="block text-white text-lg hover:text-gold transition-colors">
                +506 7107-5130
              </a>
              <a href="mailto:dsabogadocr@gmail.com" className="block text-white text-lg hover:text-gold transition-colors">
                dsabogadocr@gmail.com
              </a>
            </div>
            <h4 className="text-gray-500 text-xs font-semibold uppercase tracking-wider mb-4">
              Oficina
            </h4>
            <p className="text-gray-400 text-sm leading-relaxed">
              Cartago, Costa Rica
            </p>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col lg:flex-row justify-between items-center space-y-4 lg:space-y-0">
            {/* Social Links */}
            <div className="flex items-center space-x-6">
              <a href="#" className="text-gray-400 text-sm hover:text-gold transition-colors underline">
                LinkedIn
              </a>
              <span className="text-gray-700">|</span>
              <a href="#" className="text-gray-400 text-sm hover:text-gold transition-colors underline">
                Twitter
              </a>
              <span className="text-gray-700">|</span>
              <a href="#" className="text-gray-400 text-sm hover:text-gold transition-colors underline">
                Instagram
              </a>
            </div>

            {/* Copyright */}
            <div className="text-gray-500 text-xs text-center">
              © 2025 Abogado Penalista. Todos los derechos reservados.
            </div>

            {/* Legal Links */}
            <div className="flex items-center space-x-6">
              <a href="#" className="text-gray-400 text-sm hover:text-gold transition-colors underline">
                Política de Privacidad
              </a>
              <span className="text-gray-700">|</span>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 text-sm hover:text-gold transition-colors underline">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
